export const DATE_RANGE = 'date-range';
export const DATE_RANGE_DATE_TYPE_SELECTOR = 'date-range-date-type-selector';
export const DATE_RANGE_DISPLAYED_DATE = 'date-range-displayed-date';
export const DATE_PICKER_FOOTER_APPLY_BUTTON = 'date-picker-footer-apply';
export const DATE_PICKER_FOOTER_CANCEL = 'date-picker-footer-cancel';
export const CUSTOM_DATE_RANGE_PICKER = 'custom-date-range-picker';
export const COACHMARK_BUTTON = 'coachMark';
export const COACH_MARK_TOUR_MODAL_SKIP_BUTTON = 'tour-modal-skip-button';
export const COACH_MARK_TOUR_MODAL_TAKE_A_TOUR_BUTTON = 'tour-modal-take-a-tour-button';
export const FOOTER = 'footer';
export const SIDENAVBAR = 'side-navbar';
export const NOTIFICATION_ICON = 'notification-icon';
export const COACH_MARK_TOUR_MODAL_BANNER_IMAGE = 'coachMark-TourModal-module-bannerContainer-image';
export const COACH_MARK_TOUR_MODAL_BANNER_CONTENT = 'coachMark-TourModal-module-bannerContainer-content';
export const PAST_6_MONTHS = 'past6months';
export const THIS_MONTH = 'month';
export const THIS_WEEK = 'week';
export const YESTERDAY = 'yesterday';
export const ALL_TIME = 'allTime';
export const PAST_3_MONTHS = 'past3months';
export const TODAY = 'today';
export const CUSTOM = 'custom';
export const CLEAR_ALL = 'clear-all-filter-chips';
export const COACHMARK_FILTERS = 'coachMark-filters';
export const COACHMARK_SEARCH = 'coachMark-search';
export const COACHMARK_CUSTOM_VIEW = 'coachMark-customView';
export const DATE_PICKER_START_TIME = 'date-picker-start-time';
export const DATE_PICKER_END_TIME = 'date-picker-end-time';
export const MOBILE_DATE_PICKER_TIME = 'mobile-date-picker-time';
export const MOBILE_DATE_PICKER_CONTAINER = 'mobile-date-picker-container';
export const MOBILE_DATE_PICKER_TO_BTN = 'mobile-date-picker-to-btn';
export const MOBILE_DATE_PICKER_FROM_BTN = 'mobile-date-picker-from-btn';
export const MOBILE_DATE_PICKER_APPLY_BTN = 'mobile-date-picker-apply-btn';
export const MOBILE_DATE_PICKER_CANCEL_BTN = 'mobile-date-picker-cancel-btn';
export const DATE_PICKER_FROM_DATE_RANGE = 'date-picker-from-date-range';
export const DATE_PICKER_TO_DATE_RANGE = 'date-picker-to-date-range';
export const SEARCH_VIEW_CROSS_ICON = 'search-cross-icon';
export const CLEAR_SEARCH_BUTTON = 'clear-search-button';
export const SEARCH_CONTAINER = 'search-container';
export const DATA_TABLE = 'data-table';
export const DATA_TABLE_EMPTY_VIEW = 'data-table-empty';
export const DATA_TABLE_DATE_COLUMN = 'data-table-date-column';
export const DATA_TABLE_TXN_COPY_ICON = 'data-table-txn-copy-icon';
export const DATA_TABLE_REF_COPY_ICON = 'data-table-ref-copy-icon';
export const DATA_TABLE_UPLOADED_FILE = 'data-table-uploaded-file';
export const DATA_TABLE_DOWNLOAD_FILE = 'data-table-download-file';
export const TOAST_ICON_SUCCESS = 'toast-icon-success';
export const TOAST_ICON_ERROR = 'toast-icon-error';
export const TOAST_ICON_INFO = 'toast-icon-info';
export const TOAST_ICON_WARNING = 'toast-icon-warning';
export const TOAST_MESSAGE = 'toast-message';
export const TOAST_DESCRIPTION = 'toast-description';
export const MONTH_PICKER_MODAL = 'month-picker-modal';
export const SUCCESS_MODAL = 'success-modal';
export const SUCCESS_MODAL_CLOSE_BUTTON = 'success-modal-close-button';
export const DOWNLOAD_SAMPLE_REPORT_BUTTON = 'download-sample-report-button';
export const MORE_COLUMN_TEXT = 'more-column-text';
export const TEMPLATE_CHANGE_BUTTON = 'template-change-button';
export const RADIO_BUTTON_TEXT = 'radio-button-text';
export const LOADER = 'loader';
